import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { useUser } from '../../context/UserContext';
import { toast } from 'react-toastify';
import { useLanguage } from '../../context/LanguageContext';


const Settings: React.FC = () => {
    const { t } = useLanguage();
    const [activeTab, setActiveTab] = useState('accountSettings');
    const { logout } = useUser();
    const navigate = useNavigate()

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
    };

    const handleLogout = () => {
        logout();
        toast.success(t('toastMessage', 'logout'));
        setTimeout(() => {
            navigate('/login');
        }, 3000);
    };

    return (
        <div className="p-4 md:px-6 md:py-4  h-full rounded-lgflex flex-col  justify-between">
            <div>

                <div className="flex justify-start gap-4 pb-2 mb-4">
                    {/*TITLES*/}
                    <div
                        className={`cursor-pointer border-b-2 ${activeTab === 'accountSettings' ? 'font-semibold text-primary-color border-primary-color' : 'text-color-opacity '}`}
                        onClick={() => handleTabChange('accountSettings')}
                    >
                        {t('settings', 'accound')}
                    </div>
                    <div
                        className={`cursor-pointer border-b-2 ${activeTab === 'moreSettings' ? 'font-semibold text-primary-color  border-primary-color' : 'text-color-opacity '}`}
                        onClick={() => handleTabChange('moreSettings')}
                    >
                        {t('settings', 'more')}
                    </div>
                </div>

                {/*CONTENT*/}
                {activeTab === 'accountSettings' && (
                    <div className="flex flex-col w-full md:w-2/3 lg:w-1/3">
                        <Link to="/profile/edit"
                            className="flex justify-between gap-4 py-2 hover:bg-gray-100 rounded-lg md:px-4">
                            <span>{t('settings', 'l1')}</span>
                            <IoIosArrowForward className="text-2xl " />

                        </Link>
                        <Link to="/about-us"
                            className="flex justify-between gap-4 py-2 hover:bg-gray-100 rounded-lg md:px-4">
                            <span>{t('settings', 'l2')}</span>
                            <IoIosArrowForward className="text-2xl " />
                        </Link>

                        {/*
                        <Link to="#"
                              className="flex justify-between gap-4 py-2 hover:bg-gray-100 rounded-lg md:px-4">
                            <span>Hesabı sil</span>
                            <IoIosArrowForward className="text-2xl "/>
                        </Link>
                       */}
                    </div>
                )}
                {activeTab === 'moreSettings' && (
                    <div className="flex flex-col w-full md:w-2/3 lg:w-1/3">
                        <Link to="/all-contracts"
                            className="flex justify-between gap-4 py-2 hover:bg-gray-100 rounded-lg md:px-4 ">
                            <span>{t('settings', 'l3')}</span>
                            <IoIosArrowForward className="text-2xl " />
                            {/* <FaPlus className="text-xl text-gray-800  "/> */}
                        </Link>
                        <Link to="/all-contracts"
                            className="flex justify-between gap-4 py-2 hover:bg-gray-100 rounded-lg md:px-4">
                            <span>{t('settings', 'l4')}</span>
                            <IoIosArrowForward className="text-2xl " />
                        </Link>
                        <Link to="mailto:arge@novamedshop.com"
                            className="flex justify-between gap-4 py-2 hover:bg-gray-100 rounded-lg md:px-4">
                            <span>{t('settings', 'l5')}</span>
                            <IoIosArrowForward className="text-2xl " />
                        </Link>
                        <div
                            className="flex justify-between gap-4 py-2 hover:bg-gray-100 rounded-lg md:px-4 cursor-pointer"
                            onClick={handleLogout}>
                            <span>{t('settings', 'l6')}</span>
                            <IoIosArrowForward className="text-2xl " />
                        </div>
                    </div>
                )}
            </div>

            {/*UPDATE BUTTON*/}
            <div>
                <button
                    onClick={() => {
                        navigate("/")
                    }}
                    className="py-2 px-6 bg-primary-color text-white font-semibold rounded-lg hover:bg-red-800 transition">
                    {t('settings', 'button')}
                </button>
            </div>
        </div>
    );
};

export default Settings;
